var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 29,
    rx: 3.91304,
    transform: "matrix(-1 0 0 1 34 0)",
    fill: "#CCAE89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1133 17.8325C18.494 17.8325 19.6133 16.7132 19.6133 15.3325C19.6133 13.9518 18.494 12.8325 17.1133 12.8325C15.7326 12.8325 14.6133 13.9518 14.6133 15.3325C14.6133 16.7132 15.7326 17.8325 17.1133 17.8325Z",
    stroke: "white",
    strokeWidth: 0.916664
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78027 15.6367C8.78027 13.0825 8.78027 11.8059 9.40444 10.8892C9.67541 10.4906 10.0226 10.1496 10.4261 9.88586C11.0261 9.4917 11.7778 9.35087 12.9286 9.30087C13.4778 9.30087 13.9503 8.89253 14.0578 8.36337C14.1399 7.97576 14.3534 7.6284 14.6621 7.38C14.9707 7.13159 15.3557 6.99738 15.7519 7.00004H18.4752C19.2986 7.00004 20.0077 7.57087 20.1694 8.36337C20.2769 8.89253 20.7494 9.30087 21.2986 9.30087C22.4486 9.35087 23.2002 9.49253 23.8011 9.88586C24.2052 10.1509 24.5527 10.4917 24.8227 10.8892C25.4469 11.8059 25.4469 13.0825 25.4469 15.6367C25.4469 18.19 25.4469 19.4667 24.8227 20.3842C24.5513 20.7824 24.2041 21.1233 23.8011 21.3875C22.8669 22 21.5661 22 18.9652 22H15.2619C12.6611 22 11.3603 22 10.4261 21.3875C10.0232 21.123 9.67635 20.7818 9.40527 20.3833C9.22465 20.1134 9.09136 19.8147 9.01111 19.5M22.9469 12.8334H22.1136",
    stroke: "white",
    strokeWidth: 0.916664,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.be51dad7121b91ee8d4cb5cb031ae6f0.svg";
export { ForwardRef as ReactComponent };